const { default: axios } = require("axios");

function changeInfo() {
    let form = $(this);
    let formSynthesis = $('#form-synthesis');

    formSynthesis.find('[name="date_initial"]').val(form.find('#date_start').val());
    formSynthesis.find('[name="date_end"]').val(form.find('#date_end').val());
    formSynthesis.find('[name="date_scheduled"]').val(form.find('#date').val());
    formSynthesis.find('[name="automatic"]').val(form.find('#automatic').val());
}

function saveSynthesis() {
    let element = $(this);
    let form = element.closest('form')
    let tr = element.closest('tr');
    let td = element.closest('td');

    let url = form.attr('action');
    let subject = tr.find('.subject-synthesis').val()

    element.hide();
    element.after('<div class="spinner-border text-primary" role="status"><span class="visually-hidden"></span></div>');

    let data = {
        'subject': subject,
        'id_category': form.find('input[name="id_category"]').val(),
        'date_initial': form.find('input[name="date_initial"]').val(),
        'date_end': form.find('input[name="date_end"]').val(),
        'date_scheduled': form.find('input[name="date_scheduled"]').val(),
        'automatic': form.find('input[name="automatic"]').val(),
        'content_id': tr.find('input[name="content_id"]').val(),
        'list_id': tr.find('input[name="list_id"]').val(),
        'code': form.find('input[name="code"]').val(),
    };

    element.after(); 

    axios.post(url, data)
        .then(function (response) {
            let data = response.data;

            $('.spinner-border').remove();

            if (data.error) {
                element.show();
                // $('.container').prepend('<div class="alert alert-dan mb-0" role="alert">' + data.message + '</div>');
                Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: data.message,
                });
            } else {

                let responseHtml = '<i class="fas fa-thumbs-up"></i>';
                responseHtml += '<a href="' + data.result.linkEmail + '" target="_blank" class="ml-3 text-info"><i class="far fa-eye"></i></a>';

                td.html(responseHtml);
                // $('.container').prepend('<div class="alert alert-success mb-0" role="alert">' + data.message + '</div>');
                // Swal.fire({
                //     icon: 'success',
                //     title: 'Sucesso',
                //     text: data.message,
                // });
            }

            $('input[name="code"]').val(data.result.code);
            // setTimeout(() => {
            //     $('.alert').slideUp();
            // }, 3000);
        });
}

$(document).ready(function () {
    $(document).on('click', '.act-save-synthesis', saveSynthesis);
    $(document).on('change', '.form-pre-synthesis', changeInfo);
    $(document).on('submit', '.form-pre-synthesis', function () {
        $('#form-synthesis button').show();
    });
    $('#form-synthesis button').hide();
});
